<ng-container *transloco="let t; read: 'TICKETS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>

      <div class="right">
        <ion-button *ngIf="generatePdfRequestStatus.value !== 'pending'; else loaderTmp" (click)="getTicketPdf()" fill="none" color="secondary">
          <ion-icon slot="icon-only" name="share-outline"></ion-icon>
        </ion-button>
        <ng-template #loaderTmp>
          <app-pre-loader></app-pre-loader>
        </ng-template>
      </div>
    </div>
  </ion-toolbar>
  <ion-content>
    <div class="mt-32-desktop">
      <swiper
        *ngIf="tickets"
        [pagination]="{ dynamicBullets: true, dynamicMainBullets: 3 }"
        [slidesPerView]="1.1"
        [centeredSlides]="true"
        [initialSlide]="initialSlide"
      >
        [spaceBetween]="10">
        <ng-container *ngFor="let ticket of tickets.data; last as isLast">
          <ng-template swiperSlide>
            <div class="ticket-slide">
              <div class="site">{{ ticket.siteName }}</div>
              <div class="date-time bold mt-16 mb-24">
                <div>{{ t('TICKET_OF') }} {{ ticket.date! | translocoDate }}</div>
                <div>{{ ticket.date! | translocoDate: { timeStyle: 'medium' } }}</div>
              </div>

              <div class="flex justify-between items-center" *ngFor="let item of ticket.items">
                <div>{{ item.label }}</div>
                <div class="font-number">
                  <app-currency [value]="item.price"></app-currency>
                </div>
              </div>
              <div class="divider dashed"></div>

              <div class="flex justify-between items-center" *ngFor="let item of ticket.prices; let i = index">
                <div class="tva-percentage">{{ item.tva !== 0 ? item.label : '0.00 %' }}</div>
                <div class="price-item">
                  <div *ngIf="i === 0">{{ t('HT') }}</div>
                  <div class="font-number" *ngIf="item.ht">
                    <app-currency [value]="item.ht"></app-currency>
                  </div>
                </div>
                <div class="price-item">
                  <div *ngIf="i === 0">{{ t('TVA') }}</div>
                  <div class="font-number">
                    <app-currency [value]="item.tva ?? 0"></app-currency>
                  </div>
                </div>
                <div class="price-item">
                  <div *ngIf="i === 0">{{ t('TTC') }}</div>
                  <div class="font-number" *ngIf="item.ttc">
                    <app-currency [value]="item.ttc"></app-currency>
                  </div>
                </div>
              </div>

              <div class="divider dashed"></div>

              <div>
                <div class="flex justify-between items-center mb-8 bold" *ngIf="ticket.totalTTC">
                  <div>{{ t('TOTAL') }}</div>
                  <div class="font-number">
                    <app-currency [value]="transformtValue(ticket.totalTTC)"></app-currency>
                  </div>
                </div>

                <div class="flex justify-between items-center" *ngFor="let line of ticket.payments">
                  <div>{{ line.label }}</div>
                  <div class="font-number">
                    <app-currency [value]="line.price"></app-currency>
                  </div>
                </div>

                <div class="flex justify-between items-center" *ngIf="ticket.clientData.clientCode">
                  <div>{{ t('ACCOUNT') }}</div>
                  <div>
                    <span>
                      {{ ticket.clientData.clientCode }}
                    </span>
                    <span *ngIf="ticket.clientData.numVentilation"> / {{ ticket.clientData.numVentilation }}</span>
                  </div>
                </div>

                <div *ngIf="ticket.id">{{ userFullName }}</div>

                <div class="flex justify-between items-center" *ngIf="ticket.clientData.oldBalance">
                  <div>{{ t('OLD_BALANCE') }}</div>
                  <div class="font-number">
                    <app-currency [value]="ticket.clientData.oldBalance"></app-currency>
                  </div>
                </div>

                <div class="flex justify-between items-center" *ngIf="ticket.clientData.balance">
                  <div>{{ t('NEW_BALANCE') }}</div>
                  <div class="font-number">
                    <app-currency [value]="ticket.clientData.balance"></app-currency>
                  </div>
                </div>

                <div class="flex justify-between items-center" *ngIf="ticket.id">
                  <div>{{ t('TRANSACTION_NUMBER') }}</div>
                  <div class="font-number">{{ ticket.id }}</div>
                </div>
              </div>

              <div class="divider"></div>

              <div class="flex">{{ ticket.date! | translocoDate }} {{ ticket.date! | translocoDate: { timeStyle: 'medium' } }} {{ t('CONVENTION') }}</div>
              <div class="flex">
                <div *ngIf="ticket">{{ t('CAISSE') }} {{ ticket.legalData.caisseId }}</div>
                <div *ngIf="ticket.id">{{ t('NOTE') }} {{ ticket.id }}/1</div>
              </div>
              <div class="thanks bold mb-16">{{ t('THANKS') }}</div>

              <div class="legal-footer">
                <div class="company-name">{{ ticket.legalData.companyName }}</div>
                <div class="company-address">{{ ticket.legalData.companyAddress }}</div>
                <div class="siret mt-12">{{ t('SIRET') }} : {{ ticket.legalData.companySiret }}</div>
                <div class="naf">{{ t('NAF') }} : {{ ticket.legalData.nafCode }}</div>
                <div class="tva">{{ t('TVA_INTRA') }} : {{ ticket.legalData.intraCommunityVAT }}</div>
              </div>

              <div class="load-more" [class.reverse]="reverseArrow" *ngIf="isLast && tickets.hasMore">
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </swiper>
    </div>
  </ion-content>
</ng-container>
